/**
 * GradeKey represents all possible grade codes used in the system.
 *
 * This list is static and will never change, so it is hardcoded here in the frontend
 * to avoid unnecessary API calls and complexity.
 *
 * For any new grades or changes, both frontend and backend implementations
 * must be updated accordingly.
 */
export type GradeKey =
  | 'IT'
  | 'PR'
  | 'PK'
  | 'TK'
  | 'KG'
  | '01'
  | '02'
  | '03'
  | '04'
  | '05'
  | '06'
  | '07'
  | '08'
  | '09'
  | '10'
  | '11'
  | '12'
  | '13'
  | 'PS'
  | 'UG'
  | 'OTHER';

export const GRADES_ORDER: GradeKey[] = [
  'IT',
  'PR',
  'PK',
  'TK',
  'KG',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  'PS',
  'UG',
  'OTHER',
];
